module.exports = new __parcel__URL__("mining_paw.44a44c2d.png").toString();